/* @flow */

export const isSchoolLevelsCollapseExpanded = (state: Object, id: string) =>
  !!state.school_levels_collapse_structure[id];
